import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import CollectionsIcon from '@mui/icons-material/Collections';
import SaveIcon from '@mui/icons-material/Save';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { colors, Dialog, DialogContent } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'white',
        color: 'black',
        fontSize: 15,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
        padding: '6px 16px'
    },
}));

function Dealers() {
    const [formData, setFormData] = useState({
        reg_number: '',
        full_name: '',
        nic: '',
        mobile_number: '',
        address: ''
    });

    const [files, setFiles] = useState({
        nicFront: null,
        nicBack: null
    });

    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('success');
    const [errors, setErrors] = useState({});
    const [editDealerId, setEditDealerId] = useState(null);
    const [dealers, setDealers] = useState([]);
    console.log("Delers detail", dealers)
    const [dialogOpen, setDialogOpen] = useState(false);
    const [imageDialog, setImageDialog] = useState(false);
    const [nicFrontImage, setNicFrontImage] = useState('');
    const [nicBackImage, setNicBackImage] = useState('');
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [dealerToDeleteId, setDealerToDeleteId] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFiles(prevFiles => ({
            ...prevFiles,
            [name]: files[0]
        }));
    };

    const validate = () => {
        let tempErrors = {};
        tempErrors.reg_number = formData.reg_number ? "" : "Registration number is required.";
        tempErrors.full_name = formData.full_name ? "" : "Full name is required.";
        tempErrors.nic = formData.nic ? "" : "NIC number is required.";
        tempErrors.mobile_number = formData.mobile_number ? "" : "Mobile Number is required.";
        tempErrors.address = formData.address ? "" : "Address is required.";
        setErrors(tempErrors);
        return Object.values(tempErrors).every(x => x === "");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) {
            setMessage("Please fill in all fields correctly.");
            setSeverity('error');
            setOpen(true);
            return;
        }
        const formDataToSend = new FormData();
        formDataToSend.append('reg_number', formData.reg_number);
        formDataToSend.append('full_name', formData.full_name);
        formDataToSend.append('nic', formData.nic);
        formDataToSend.append('mobile_number', formData.mobile_number);
        formDataToSend.append('address', formData.address);
        formDataToSend.append('nicFront', files.nicFront);
        formDataToSend.append('nicBack', files.nicBack);

        try {
            if (editDealerId) {
                const response = await axios.put(`https://servermunidasa.ccsoftwares.com/Dealers/updateDealer/${editDealerId}`, formDataToSend, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                setMessage('Dealer updated successfully!');
            } else {
                const response = await axios.post('https://servermunidasa.ccsoftwares.com/Dealers/createDealers', formDataToSend, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                setMessage('Dealer added successfully!');
            }
            fetchDealers();
            setSeverity('success');
            setOpen(true);

            setFormData({
                reg_number: '',
                full_name: '',
                nic: '',
                mobile_number: '',
                address: ''
            });

            setFiles({
                nicFront: null,
                nicBack: null
            });
            setEditDealerId(null);

        } catch (error) {
            console.error(error);
            setMessage('Failed to add dealer. Please try again.');
            setSeverity('error');
            setOpen(true);
        }
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    useEffect(() => {
        fetchDealers();
    }, []);

    const fetchDealers = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://servermunidasa.ccsoftwares.com/Dealers/getDealers');
            const data = await response.json();
            setDealers(data);
        } catch (error) {
            console.error('Error fetching dealers:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleEditDealer = (dealer) => {
        setFormData({
            reg_number: dealer.reg_number,
            full_name: dealer.full_name,
            nic: dealer.nic,
            mobile_number: dealer.mobile_number,
            address: dealer.address,
        });
        setFiles({
            nicFront: dealer.nic_front || '',
            nicBack: dealer.nic_back || ''
        });
        setEditDealerId(dealer.id);
        setDialogOpen(true);

    };

    const handleDeleteDealerClick = (id) => {
        setDealerToDeleteId(id);
        setDeleteDialogOpen(true);
    };

    const handleConfirmDelete = async () => {
        try {
            await axios.delete(`https://servermunidasa.ccsoftwares.com/Dealers/deleteDealer/${dealerToDeleteId}`);
            fetchDealers();
            setMessage('Dealer deleted successfully!');
            setSeverity('success');
            setOpen(true);
        } catch (error) {
            console.error('Error deleting dealer:', error);
            setMessage('Failed to delete dealer. Please try again.');
            setSeverity('error');
            setOpen(true);
        } finally {
            setDeleteDialogOpen(false);
            setDealerToDeleteId(null);
        }
    };

    const handleCancelDelete = () => {
        setDeleteDialogOpen(false);
        setDealerToDeleteId(null);
    };


    // const handleDeleteDealer = async (id) => {
    //     try {
    //         await axios.delete(`https://servermunidasa.ccsoftwares.com/Dealers/deleteDealer/${id}`);
    //         fetchDealers();
    //         setMessage('Dealer Deleted successfully!');
    //         setSeverity('success');
    //         setOpen(true);
    //     } catch (error) {
    //         console.error('Error deleting dealer:', error);
    //         setMessage('Failed to delete dealer. Please try again.');
    //         setSeverity('error');
    //         setOpen(true);
    //     }
    // };

    const handleDialogOpen = () => {
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleViewImages = (nicFront, nicBack) => {
        setNicFrontImage(nicFront);
        console.log(nicFront)
        setNicBackImage(nicBack);
        setImageDialog(true);
    };

    const removeImage = () => {
        setImageDialog(false);
        setNicFrontImage('');
        setNicBackImage('');
    };

    const navigate = useNavigate();

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            color: 'black',
            fontWeight: 'bold',
            fontSize: '2rem',
            minHeight: '100vh',
            paddingTop: '20px',
        }}>
            <Card sx={{ width: '97%', padding: '20px', marginTop: '20px' }}>
                <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <button
                            style={{
                                backgroundColor: 'white',
                                color: 'Black',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: 30,
                                marginTop: 5,
                            }}
                            onClick={() => navigate(-1)}
                        > <ArrowCircleLeftIcon fontSize='2' />
                        </button>
                        <h2 style={{ margin: 0 }}>DEALERS</h2>
                        <Button
                            variant="outlined"
                            sx={{ color: 'black', borderColor: 'black' }}
                            startIcon={<AddCircleOutlineIcon />}
                            onClick={handleDialogOpen}
                        >
                            Add Dealer
                        </Button>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                        <TextField
                            size='small'
                            variant="outlined"
                            placeholder="Search Dealer"
                            sx={{
                                marginTop: '5px',
                                width: '35%',
                                marginBottom: '20px',
                                borderRadius: '15px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '30px',
                                }
                            }}
                            InputProps={{
                                startAdornment: (
                                    <SearchIcon sx={{ marginRight: '8px', color: 'grey' }} />
                                )
                            }}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
                        />
                    </Box>
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                            <svg width={0} height={0}>
                                <defs>
                                    <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                        <stop offset="0%" stopColor="#e01cd5" />
                                        <stop offset="100%" stopColor="#1CB5E0" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} />
                        </Box>
                    ) : (
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <TableContainer component={Paper} sx={{ width: '100%', maxHeight: '550px' }}>
                                <Table stickyHeader sx={{ minWidth: 700, }} aria-label="customized table">
                                    <TableHead sx={{ color: '#cacaca' }}>
                                        <TableRow>
                                            <StyledTableCell><b>ID</b></StyledTableCell>
                                            <StyledTableCell><b>NAME</b></StyledTableCell>
                                            <StyledTableCell><b>NIC</b></StyledTableCell>
                                            <StyledTableCell><b>PHONE</b></StyledTableCell>
                                            <StyledTableCell><b>ADDRESS</b></StyledTableCell>
                                            {/* <StyledTableCell><b>NIC IMAGE</b></StyledTableCell> */}
                                            <StyledTableCell><b>ACTION</b></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {dealers.filter(dealer => dealer.full_name.toLowerCase().includes(searchQuery)).map((dealer) => (
                                            <StyledTableRow key={dealer.id}>
                                                <StyledTableCell width={'140px'}>{dealer.reg_number}</StyledTableCell>
                                                <StyledTableCell width={'250px'}>{dealer.full_name}</StyledTableCell>
                                                <StyledTableCell width={'150px'}>{dealer.nic}</StyledTableCell>
                                                <StyledTableCell width={'180px'}>{dealer.mobile_number}</StyledTableCell>
                                                <StyledTableCell width={'300px'}>{dealer.address}</StyledTableCell>
                                                {/* <StyledTableCell>
                                                    <IconButton
                                                        aria-label="view images"
                                                        onClick={() => handleViewImages(dealer.nic_front, dealer.nic_back)}
                                                    >
                                                        <CollectionsIcon />
                                                    </IconButton>
                                                </StyledTableCell> */}
                                                <StyledTableCell>
                                                    <IconButton aria-label="edit" onClick={() => handleEditDealer(dealer)}>
                                                        <EditIcon />
                                                    </IconButton>
                                                    <IconButton aria-label="delete" onClick={() => handleDeleteDealerClick(dealer.id)}>
                                                        <DeleteForeverIcon />
                                                    </IconButton>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    )}
                </CardContent>
            </Card>

            {/* Dialog to show NIC images */}
            <Dialog open={imageDialog} onClose={removeImage}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        paddingTop: "1vh",
                        paddingRight: "1vw",
                    }}
                >
                    <IconButton onClick={removeImage}>
                        <CancelIcon sx={{ color: "red" }} />
                    </IconButton>
                </Box>
                <DialogContent>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 2,
                        }}
                    >
                        <Card
                            style={{
                                height: 400,
                                width: 300,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            {nicFrontImage ? (
                                <img
                                    src={`https://servermunidasa.ccsoftwares.com/Images/${nicFrontImage}`}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                    }}
                                    alt="NIC Front"
                                />
                            ) : (
                                <p>No NIC Front Image</p>
                            )}
                        </Card>
                        <Card
                            style={{
                                height: 400,
                                width: 300,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            {nicBackImage ? (
                                <img
                                    src={`https://servermunidasa.ccsoftwares.com/Images/${nicBackImage}`}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                    }}
                                    alt="NIC Back"
                                />
                            ) : (
                                <p>No NIC Back Image</p>
                            )}
                        </Card>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Form Dialog */}
            <Dialog open={dialogOpen} onClose={handleDialogClose} >
                <Card sx={{ minWidth: 250, minHeight: 150, borderRadius: 3 }}>
                    <CardContent>
                        <IconButton
                            onClick={handleDialogClose}
                            sx={{
                                color: 'red',
                                position: 'absolute',
                                top: -5,
                                right: -5,
                                borderRadius: '50%',
                            }}
                        >
                            <HighlightOffIcon />
                        </IconButton>
                        <Typography variant="h5" component="div" sx={{ mb: 2, textAlign: 'center' }}>
                            Dealer Details
                        </Typography>
                        <Typography variant="h5" component="div">
                            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>

                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <TextField
                                                label="Registration Number"
                                                required
                                                name="reg_number"
                                                size='small'
                                                value={formData.reg_number}
                                                onChange={handleChange}
                                                error={!!errors.reg_number}
                                                helperText={errors.reg_number}
                                                sx={{ m: 1, width: '25ch' }}
                                            />
                                            <TextField
                                                label="Full Name"
                                                required
                                                name="full_name"
                                                size='small'
                                                value={formData.full_name}
                                                onChange={handleChange}
                                                error={!!errors.full_name}
                                                helperText={errors.full_name}
                                                sx={{ m: 1, width: '25ch' }}
                                            />
                                        </div>

                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <TextField
                                                label="NIC Number"
                                                required
                                                name="nic"
                                                size='small'
                                                value={formData.nic}
                                                onChange={handleChange}
                                                error={!!errors.nic}
                                                helperText={errors.nic}
                                                sx={{ m: 1, width: '25ch' }}
                                                inputProps={{ maxLength: 12 }}
                                            />
                                            <TextField
                                                label="Mobile Number"
                                                name="mobile_number"
                                                required
                                                size='small'
                                                value={formData.mobile_number}
                                                onChange={handleChange}
                                                error={!!errors.mobile_number}
                                                helperText={errors.mobile_number}
                                                sx={{ m: 1, width: '25ch' }}
                                                inputProps={{ maxLength: 10 }}
                                            />
                                        </div>

                                        <div style={{ display: 'flex' }}>
                                            <TextField
                                                label="Address"
                                                required
                                                name="address"
                                                size='small'
                                                value={formData.address}
                                                onChange={handleChange}
                                                error={!!errors.address}
                                                helperText={errors.address}
                                                sx={{ m: 1, width: 'calc(50ch + 20px)' }}
                                            />
                                        </div>

                                        {/* <div style={{ display: 'flex', gap: '10px' }}>
                                            <TextField
                                                type="file"
                                                name="nicFront"
                                                size='small'
                                                onChange={handleFileChange}
                                                error={!!errors.nicFront}
                                                helperText={errors.nicFront}
                                                InputLabelProps={{ shrink: true }}
                                                label="NIC Front Image"
                                                style={{ margin: '8px', width: '25ch' }}
                                            />
                                            <TextField
                                                type="file"
                                                name="nicBack"
                                                size='small'
                                                onChange={handleFileChange}
                                                error={!!errors.nicBack}
                                                helperText={errors.nicBack}
                                                InputLabelProps={{ shrink: true }}
                                                label="NIC Back Image"
                                                style={{ margin: '8px', width: '25ch' }}
                                            />
                                        </div> */}

                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                        <Button
                                            variant="outlined"
                                            sx={{ color: '#118AB2', borderColor: '#118AB2', marginRight: '10px' }}
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </form>
                            </Box>
                        </Typography>
                    </CardContent>
                </Card>
            </Dialog>

            {/* Delete Dialog */}
            <Dialog
                open={deleteDialogOpen}
                onClose={handleCancelDelete}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <Typography id="alert-dialog-description">
                        Are you sure you want to delete this dealer?
                    </Typography>
                </DialogContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '10px 70px' }}>
                    <Button variant="outlined" color="error" onClick={handleConfirmDelete}>
                        OK
                    </Button>
                    <Button variant="outlined" onClick={handleCancelDelete}>
                        Cancel
                    </Button>
                </Box>
            </Dialog>


            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default Dealers;
